import { Component, OnInit, ViewChild, ElementRef, HostListener, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs'
import { fabric } from 'fabric';

import { User } from '../_models/user.model';
import { AuthService } from '../_services/auth.service';
import { PortService } from '../_services/port.service';
import { ProjectService } from '../_services/project.service';
import { FacilityService } from '../_services/facility.service';
import { AddFacilityDialogComponent } from './add-facility/add-facility.component';
import { EditFacilityDialogComponent } from './edit-facility/edit-facility.component';

import { Slug } from 'ng2-slugify';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';

// Save additional attributes in Serialization
fabric.Object.prototype.toObject = (toObject => function (properties) {
    return fabric.util.object.extend(toObject.call(this, properties), {
        textID: this.textID
    });
})(fabric.Object.prototype.toObject);

@Component({
    templateUrl: './port.component.html',
    styleUrls: ['./port.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('sidebar', [
            state('void', style({ transform: 'translateX(100%)' })),
            transition(':enter', animate('150ms ease-in', style({ transform: 'translateX(0)' }))),
            transition(':leave', animate('200ms ease-out', style({ transform: 'translateX(100%)' })))
        ]),
        trigger('blanket', [
            state('void', style({ opacity: '0', zIndex: '-1' })),
            transition('void => *', animate('200ms ease-in', style({ opacity: '0.75', zIndex: '100' }))),
            transition('* => void', animate('200ms ease-out', style({ opacity: '0', zIndex: '-1' })))
        ])
    ]
})
export class PortComponent implements OnInit {

    private busy: Boolean;
    private portId: number;
    private slug: string;
    private urlFacilityId: number;

    private slugify: Slug;

    private hasDropOver: boolean;

    private selectedType: string;
    private selectedYear: number;
    private currentYear: number;
    private years = [];
    private points = [];

    private port: any = {};

    // Add Facility-related properties
    private lastAddedFacilityPoint: any;

    // Edit Facility-related properties
    private oldFacilityX: number;
    private oldFacilityY: number;

    // Map uploader-related properties
    private mapUploadFormData: FormData;

    // Map-related properties
    private highlightMap: boolean;
    private mapMode: string = null;

    // Sidebar-related properties
    private sidebarTab: string = 'facilities';
    private sidebarMode: string = 'list-facilities';
    private sidebarBusy: boolean = false;
    private selectedFacility: any;
    private selectedProjectReposition: any;
    private searchFacilityKeyword: string;
    private filteredFacilities: any = null;
    private projectStatuses: any = ["Bidding", "On-going", "Completed"];
    private filteredProjects: any = null;
    private searchProjectKeyword: string;
    private searchProjectStatus: string;

    // Map canvas-related properties
    @ViewChild('map') map: ElementRef;
    private canvas: any;
    private radius: number;
    private initialW: number;
    private initialH: number;
    private scaleFactor: number;

    private selectedGroup: any;
    private defaultColorStops = ['#33A5EE', '#3087E6'];
    private selectedColorStops = ['#FE3F81', '#CE5D57'];
    private facilitiesFlat = [];
    private typesFlat = {};
    private mapPointCountdown: number = 2;

    private user: any;

    constructor(private router: Router,
        private activatedRoute: ActivatedRoute,
        private portService: PortService,
        private projectService: ProjectService,
        private facilityService: FacilityService,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private authService: AuthService) {
        this.slugify = new Slug('');
    }

    ngOnInit() {
        this.busy = true;
        this.user = this.authService.getUser();

        let params = this.activatedRoute.snapshot.params;
        this.currentYear = new Date().getFullYear();

        this.portId = parseInt(params['portId']);
        this.slug = params['slug'];
        this.urlFacilityId = params['facilityId'];

        for (var i = this.currentYear - 5; i <= this.currentYear + 5; i++) {
            this.years.push(i);
        }

        this.activatedRoute.params.subscribe(params => {
            this.selectedYear = parseInt(params['year']) || this.currentYear;
            this.selectedType = params['type'] || 'planning';

            this.reloadPort();
        });
    }

    private noop() { }
    private hasPermission(permission) {
    }

    // Timeline-related
    public selectYear(year) {
        this.router.navigate(['/port', this.portId, this.slug, year]);
    }

    private reloadPort() {
        this.mapPointCountdown = 2;
        this.busy = true;

        this.portService.getPort(this.portId, this.selectedYear, this.selectedType).subscribe(
            response => {
                let result = response.json().Result;
                if (this.selectedType !== 'google') {
                    this.initializePort(result);
                    this.initializeMapPointCountdown();
                } else {
                    this.port = result;
                }

                this.calculatePermissions();

                this.busy = false;
            }, error => {
                setTimeout(() => {
                    this.initializePort(null);
                    this.busy = false;
                }, 3000);
            });
    }

    private isAllowed: any = {};
    private calculatePermissions() {
        let portOfficeId = this.port.OfficeId + '';
        switch (this.user.Role) {
            case 'GlobalAdministrator':
                this.isAllowed['planning'] = true;
                this.isAllowed['navigation'] = true;
                this.isAllowed['sounding'] = true;
                this.isAllowed['google'] = true;
                break;
            case 'PPAExecutive':
                break;
            case 'PMOAdmin':
                if (this.user.OfficeIds != null && this.user.OfficeIds.indexOf(portOfficeId) != -1) {
                    this.isAllowed['planning'] = true;
                    this.isAllowed['navigation'] = true;
                    this.isAllowed['sounding'] = true;
                    this.isAllowed['google'] = true;
                }
                break;
            case 'PPAPlanning':
                this.isAllowed['planning'] = true;
                break;
            case 'PPADredging':
                this.isAllowed['navigation'] = true;
                this.isAllowed['sounding'] = true;
                break;
            case 'PPAPortConstruction':
                this.isAllowed['planning'] = true;
                break;
        }
    }

    private initializePort(port) {
        if (port == null) {
            this.port = {
                Id: null,
                MapUrl: null,
                Year: this.currentYear
            };

            return;
        }

        if (port.MapUrl) {
            port.MapUrl = port.MapUrl + '&' + new Date().getTime();
        }

        this.port = port;

        if (this.selectedType != 'navigation') {
            this.facilitiesFlat = [];
            this._foreachFacility((node) => {
                this.facilitiesFlat.push({ nest: node.nest, value: node.node });
            });
        } else {
            this.facilitiesFlat = [];
        }

        // Add stops to projects
        this.port.Projects.forEach((project) => {
            let type = project.Type;
            let color = '#' + type.Color;
            let lighter = this.shadeColor2(color, 0.3);
            type.Stops = [lighter, color];
        });

        this.typesFlat = {};
        this.port.ProjectTypes.forEach((type) => {
            let color = '#' + type.Color;
            let lighter = this.shadeColor2(color, 0.3);
            type.Stops = [lighter, color];

            if (type.Checked == undefined) {
                type.Checked = true;
            }

            this.typesFlat[type.Id] = type;
        });
    }

    // Facility-related
    private _foreachFacility(callback: Function) {
        let s = [];
        this.port.Facilities.slice().reverse().forEach((node) => {
            s.push({ nest: [], node: node });
        });

        while (s.length > 0) {
            let node = s.pop();
            callback(node);

            if (node.node.Children) {
                node.node.Children.slice().reverse().forEach((child) => {
                    let nest = node.nest.slice();
                    nest.push(node.node.Title);
                    s.push({ nest: nest, node: child });
                });
            } else if (node.node.Facilities) {
                node.node.Facilities.slice().reverse().forEach((child) => {
                    let nest = node.nest.slice();
                    nest.push(node.node.Title);
                    s.push({ nest: nest, node: child });
                });
            }
        }
    }

    private addFacility() {
        let dialogRef = this.dialog.open(AddFacilityDialogComponent,
            {
                disableClose: false,
                hasBackdrop: true,
                backdropClass: '',
                width: '500px',
                height: '',
                position: {
                    top: '',
                    bottom: '',
                    left: '',
                    right: ''
                },
                data: {
                    facilities: this.facilitiesFlat,
                    portId: this.portId,
                    mapId: this.port.MapId,
                    year: this.selectedYear
                }
            });

        dialogRef.beforeClose().subscribe(result => {
            this.reloadPort();
        });
    }

    private cancelAddFacility() {
        this.canvas.remove(this.lastAddedFacilityPoint);
        this.lastAddedFacilityPoint = null;
        this._highlightMap(null);
    }

    private editFacility(item: any) {
        this.selectedFacility = item;
        let dialogRef = this.dialog.open(EditFacilityDialogComponent, {
            disableClose: false,
            hasBackdrop: true,
            backdropClass: '',
            width: '500px',
            height: '',
            position: {
                top: '',
                bottom: '',
                left: '',
                right: ''
            },
            data: {
                facility: this.selectedFacility
            }
        });

        dialogRef.beforeClose().subscribe(result => {
            if (result) {
                this.selectedFacility.Title = result.Facility.Title;
                this.selectedFacility.Unit = result.Facility.Unit;
                this.selectedFacility.ParticularsToDate = result.Facility.ParticularsToDate;
            }
        });
    }

    private editProjectReposition(project) {
        this._highlightMap('edit-project');

        this.selectedProjectReposition = project;

        let groups = this.canvas.getObjects();
        let selectedGroup = groups.find(group => group.id == this.selectedProjectReposition.Id);

        this.selectedGroup = selectedGroup;
        this.selectProject(selectedGroup);
        this._toggleGroupObjects(selectedGroup, true);

        this._changeGroupColor(selectedGroup, this.selectedColorStops);
        selectedGroup.lockMovementX = false;
        selectedGroup.lockMovementY = false;

        this.oldFacilityX = selectedGroup.get('left');// + this.radius) / this.canvas.getWidth();
        this.oldFacilityY = selectedGroup.get('top');// + this.radius) / this.canvas.getHeight();

        this.port.Projects.forEach((project) => {
            if (project.Id != this.selectedProjectReposition.Id) {
                let otherGroup = groups.find(group => group.id == project.Id);
                if (otherGroup != null) {
                    otherGroup.opacity = 0.3;
                }
            }
        });

        this.canvas.renderAll();
    }

    private nextEditProjectReposition() {
        let groups = this.canvas.getObjects();
        let selectedGroup = groups.find(group => group.id == this.selectedProjectReposition.Id);
        let selectedGroupPoint = selectedGroup.item(4);
        selectedGroup.lockMovementX = true;
        selectedGroup.lockMovementY = true;

        let x = (selectedGroupPoint.group.get('left')) / this.canvas.getWidth();
        let y = (selectedGroupPoint.group.get('top') - this.radius) / this.canvas.getHeight();

        this.busy = true;
        this.projectService.updateProjectPosition({
            ProjectId: this.selectedProjectReposition.Id,
            X: x,
            Y: y
        }).subscribe(response => {
            this.snackBar.open('Project was updated successfully.', null, { duration: 2000 });
            selectedGroup.project.X = x;
            selectedGroup.project.Y = y;

            this.busy = false;

            this.port.Projects.forEach((project) => {
                if (project.Id != this.selectedProjectReposition.Id) {
                    let otherGroup = groups.find(group => group.id == project.Id);
                    if (otherGroup != null) {
                        otherGroup.opacity = 1;
                    }
                }
            });

            this.selectedProjectReposition = null;
            this.canvas.renderAll();
            this._highlightMap(null);

            this.canvas.renderAll();
        }, errorResponse => {
            let error = errorResponse.Message;//.json();

            this.snackBar.open('Failed to updated project.', null, { duration: 2000 });
            this.busy = false;

            this.port.Projects.forEach((project) => {
                if (project.Id != this.selectedProjectReposition.Id) {
                    let otherGroup = groups.find(group => group.id == project.Id);
                    if (otherGroup != null) {
                        otherGroup.opacity = 1;
                    }
                }
            });

            this.selectedProjectReposition = null;
            this.canvas.renderAll();
            this._highlightMap(null);
        });
    }

    private cancelEditProjectReposition() {
        let groups = this.canvas.getObjects();
        let selectedGroup = groups.find(group => group.id == this.selectedProjectReposition.Id);
        selectedGroup.set({ left: this.oldFacilityX, top: this.oldFacilityY });
        selectedGroup.setCoords();
        groups.forEach(group => {
            group.opacity = 1;
        });

        this.lastAddedFacilityPoint = null;
        this.selectedProjectReposition = null;
        this.canvas.renderAll();
        this._highlightMap(null);
    }

    private searchFacility(keyword) {
        let groups = this.canvas.getObjects();

        // Set all to visible first
        this._foreachFacility((node) => {
            let otherGroup = groups.find(group => group.id == node.node.Id);
            if (otherGroup != null) {
                otherGroup.visible = true;
            }
        });

        this.filteredFacilities = null;
        if (keyword != null && keyword != '') {
            this.filteredFacilities = [];
            this._foreachFacility((node) => {
                if (node.node.Title.toLowerCase().indexOf(keyword.toLowerCase()) == -1) {
                    let otherGroup = groups.find(group => group.id == node.node.Id);
                    if (otherGroup != null) {
                        otherGroup.visible = false;
                    }
                } else {
                    this.filteredFacilities.push(node.node);
                }
            });
        }

        this.canvas.renderAll();
    }

    // Project-related
    private addProject() {
        this._highlightMap('add-project');
    }

    private nextAddProject() {
        let x = this.lastAddedFacilityPoint == null ? null : this.lastAddedFacilityPoint.get('left');
        let y = this.lastAddedFacilityPoint == null ? null : this.lastAddedFacilityPoint.get('top');

        if (x != null && y != null) {
            x = x / this.canvas.getWidth();
            y = y / this.canvas.getHeight();
        }

        this.router.navigate(['/', this.portId, this.slug, 'map', this.selectedYear, this.selectedType, 0, 'projects', 'add-project', x, y]);
    }

    private cancelAddNavigationProject() {
        this.canvas.remove(this.lastAddedFacilityPoint);
        this.lastAddedFacilityPoint = null;
        this._highlightMap(null);
    }

    private selectProject(group) {
        if (this.sidebarBusy) {
            return;
        }

        this.sidebarTab = 'projects';
        group.project.Expanded = true;
    }

    private deselectProject() {
        if (this.selectedGroup != null) {
            this._toggleGroupObjects(this.selectedGroup, false);
            this._changeGroupColor(this.selectedGroup, this.selectedGroup.project.Type.Stops);
            this.selectedGroup.project.Expanded = false;
        }

        this.canvas.renderAll();
        this.selectedGroup = null;
        this.selectedFacility = null;
    }

    private uploadMap(files: File[]): Subscription {
        this.busy = true;
        let file = files.pop();

        return this.portService.uploadPortMap(this.portId, this.selectedYear, this.selectedType, file)
            .subscribe(response => {
                setTimeout(() => {
                    this.reloadPort();
                }, 2000);
            });
    }

    private searchProject(keyword, status) {
        this.filteredProjects = [];
        if ((keyword != null && keyword != '') || (status != null && status.length > 0)) {
            this.filteredProjects = [];
        }

        this.port.Projects.forEach(project => {
            let addKeyword = false;
            let addStatus = false;

            // Show or hide object from map
            let checkType = this.typesFlat[project.Type.Id];
            let groups = this.canvas.getObjects();
            let group = groups.find(group => group.id == project.Id);

            group.visible = checkType.Checked;

            if (keyword != null && keyword != '' && project.Title.toLowerCase().indexOf(keyword.toLowerCase()) != -1) {
                addKeyword = true;
            }

            if (status != null && status.indexOf(project.Status) != -1) {
                addStatus = true;
            }

            if ((keyword != null && keyword != '') && (status != null && status.length > 0) && addKeyword && addStatus) {
                this.filteredProjects.push(project);
            } else if ((keyword != null && keyword != '') && (status == null || status.length == 0) && addKeyword) {
                this.filteredProjects.push(project);
            } else if ((status != null && status.length > 0) && (keyword == null || keyword == '') && addStatus) {
                this.filteredProjects.push(project);
            } else if ((keyword == null || keyword == '') && (status == null || status.length == 0) && group.visible) {
                this.filteredProjects.push(project);
            } else {
                group.visible = false;
            }
        });
        
        this.canvas.renderAll();
    }

    // Google Maps related
    private canEditGoogleMap: boolean = false;
    private oldGoogleMapUrl: String = '';
    private editGoogleMap() {
        this.canEditGoogleMap = true;
        this.oldGoogleMapUrl = this.port.MapUrl;
        this._highlightMap('edit-google-map');
    }

    private nextEditGoogleMap() {
        this.busy = true;
        this.portService.updateGoogleMap(this.portId, this.port.MapUrl)
            .subscribe(response => {
                let result = response.json().Result;
                this.snackBar.open('Google Map has successfully been updated.', null, { duration: 2000 });
                this.busy = false;

                this.canEditGoogleMap = false;
                this._highlightMap(null);
            },
            response => {
                this.port.MapUrl = this.oldGoogleMapUrl;
                this.snackBar.open('Failed to update Google Map.', null, { duration: 2000 });
                this.busy = false;
            });
    }

    private cancelEditGoogleMap() {
        this.canEditGoogleMap = false;
        this._highlightMap(null);
    }

    // Canvas-related methods
    private initializeMap() {
        let self = this;
        this.canvas = new fabric.Canvas('mapCanvas');

        this.canvas.selection = false;
        if (this.map.nativeElement) {
            this.canvas.setWidth(this.map.nativeElement.clientWidth);
            this.canvas.setHeight(this.map.nativeElement.clientHeight);

            this.initialW = this.map.nativeElement.clientWidth;
            this.initialH = this.map.nativeElement.clientHeight;
        }

        this.radius = this.initialW / 140;
        this.scaleFactor = 1;

        // piggyback on `canvas.findTarget`, to fire "object:over" and "object:out" events
        this.canvas.findTarget = (function (originalFn) {
            return function () {
                var target = originalFn.apply(this, arguments);
                if (target) {
                    if (this._hoveredTarget !== target) {
                        self.canvas.fire('object:over', { target: target });
                        if (this._hoveredTarget) {
                            self.canvas.fire('object:out', { target: this._hoveredTarget });
                        }
                        this._hoveredTarget = target;
                    }
                }
                else if (this._hoveredTarget) {
                    self.canvas.fire('object:out', { target: this._hoveredTarget });
                    this._hoveredTarget = null;
                }
                return target;
            };
        })(this.canvas.findTarget);

        this.canvas.on('object:over', event => this._toggleGroupObjects(event.target, true));
        this.canvas.on('object:out', event => {
            if (event.target === this.selectedGroup) return;

            this._toggleGroupObjects(event.target, false);
        });
        
        this.canvas.on('mouse:down', (event) => { this._onCanvasClick(event) });
        this.canvas.on('object:selected', (event) => { this._onCanvasPointClicked(event); });
        this.canvas.on('before:selection:cleared', (event) => { this._onCanvasPointUnselected(event); });

        this.initializeMapPointCountdown();

        this.lastAddedFacilityPoint = null;
    }

    private _toggleGroupObjects(group, toggle) {
        if (!group.isType('group')) {
            return;
        }

        group.bringToFront();
        let objects = group.getObjects();
        objects.forEach(object => {
            if (!object.isType('circle')) {
                object.visible = toggle;
            }
        });

        this.canvas.renderAll();
    }

    private initializeMapPointCountdown() {
        this.mapPointCountdown--;
        if (this.mapPointCountdown <= 0) {
            this.port.Projects.forEach(project => {
                this._addProjectPoint(project.X * this.canvas.getWidth(), project.Y * this.canvas.getHeight(), project.Title, project);
            });
        }
    }

    // New stuff
    private switchSidebarTab(tab) {
        this.sidebarTab = tab;
    }

    private toggleProjectType(type) {
        type.Checked = !type.Checked;
        this.searchProject(this.searchProjectKeyword, this.searchProjectStatus);
        // Re-render projects
        //this.port.Projects.forEach(project => {
        //    let checkType = this.typesFlat[project.Type.Id];
        //    let groups = this.canvas.getObjects();
        //    let group = groups.find(group => group.id == project.Id);

        //    group.visible = checkType.Checked;
        //});

        //this.canvas.renderAll();
    }

    private _addProjectPoint(x, y, title, project) {
        this.lastAddedFacilityPoint = new fabric.Circle({
            originX: 'center',
            originY: 'center',
            radius: this.radius,
            fill: 'blue',
            stroke: 'white'
        });

        this.lastAddedFacilityPoint.setGradient('fill',
            {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: this.lastAddedFacilityPoint.height,
                colorStops: project.Type.Stops
            }).setShadow({
                color: 'rgba(0,0,0,0.2)',
                blur: 1,
                strokeShadow: true
            });

        let text = new fabric.Text(title,
            {
                top: this.lastAddedFacilityPoint.get('top') - 35,
                originX: 'center',
                originY: 'center',
                fontSize: 16,
                fill: 'white',
                fontFamily: 'Roboto',
                visible: false
            });

        let rect = new fabric.Rect({
            originX: 'center',
            originY: 'center',
            width: text.get('width') + 12,
            height: text.get('height') + 12,
            left: text.get('left'),
            top: text.get('top'),
            stroke: 'white',
            rx: 3,
            ry: 3,
            visible: false
        });

        rect.setGradient('fill',
            {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: rect.height,
                colorStops: project.Type.Stops
            }).setShadow({
                color: 'rgba(0,0,0,0.8)',
                offsetX: 0,
                offsetY: 2,
                blur: 2,
                strokeShadow: true
            });

        let tri = new fabric.Triangle({
            originX: 'center',
            originY: 'center',
            width: 20,
            height: 7,
            top: rect.get('top') + rect.get('height') / 2 + 3,
            fill: 'white',
            angle: 180,
            visible: false
        });

        tri.setShadow({
            color: 'rgba(0,0,0,0.8)',
            offsetX: 0,
            offsetY: 2,
            blur: 2,
            strokeShadow: true
        });

        let tri2 = new fabric.Triangle({
            originX: 'center',
            originY: 'center',
            width: 20,
            height: 7,
            top: rect.get('top') + rect.get('height') / 2 + 1,
            fill: project.Type.Stops[1],
            angle: 180,
            visible: false
        });

        let group = new fabric.Group([rect, tri, tri2, text, this.lastAddedFacilityPoint],
            {
                left: x + 2,
                top: y + this.radius + 2,
                originX: 'center',
                originY: 'bottom',
                lockScalingX: true,
                lockScalingY: true,
                lockRotation: true,
                lockMovementX: true,
                lockMovementY: true,
                hasControls: false,
                hasBorders: false,
                hoverCursor: 'pointer',
                perPixelTargetFind: true
            });

        group.project = project;
        group.id = project.Id;

        this.canvas.add(group);
    }

    private _onCanvasPointClicked(event) {
        if (this.mapMode != null) {
            return;
        }

        if (this.selectedProjectReposition != null) {
            return;
        }

        if (this.selectedGroup == event.target) {
            return;
        }

        let group = this.selectedGroup = event.target;
        this._changeGroupColor(group, this.selectedColorStops);
        this.selectProject(group);
    }

    private _onCanvasPointUnselected(event) {
        if (this.selectedProjectReposition != null) {
            return;
        }

        let group = this.selectedGroup;
        if (group != null) {
            this.deselectProject();
        }
    }

    private _onCanvasClick(event) {
        if (this.selectedProjectReposition != null) {
            return;
        }

        let evt = event.e;

        const pointer = this.canvas.getPointer(evt);
        const x = pointer.x;
        const y = pointer.y;
        
        if (this.mapMode === 'add-project') {
            if (event.target || this.lastAddedFacilityPoint != null) {
                return;
            }

            this.lastAddedFacilityPoint = new fabric.Circle({
                left: x,
                top: y,
                originX: 'center',
                originY: 'center',
                radius: this.radius,
                fill: 'blue',
                stroke: 'white',
                lockScalingX: true,
                lockScalingY: true,
                lockRotation: true,
                hasControls: false,
            });

            this.lastAddedFacilityPoint.setGradient('fill',
                {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: this.lastAddedFacilityPoint.height,
                    colorStops: this.defaultColorStops 
                }).setShadow({
                    color: 'rgba(0,0,0,0.2)',
                    blur: 1,
                    strokeShadow: true
                });

            this.canvas.add(this.lastAddedFacilityPoint);

            return;
        }

        // For navigation
        if (this.selectedGroup !== event.target) {
            if (this.selectedGroup != null) {
                this.deselectProject();
            }

            if (event.target != null) {
                this._changeGroupColor(event.target, this.selectedColorStops);
                this.selectedGroup = event.target;
                this.selectProject(this.selectedGroup);
            }
        }
    }

    private shadeColor2(color, percent) {
        var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
        return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
    }

    private _changeGroupColor(group, colors) {
        let rect = group.item(0);
        rect.setGradient('fill',
            {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: rect.height,
                colorStops: colors
            });

        let tri2 = group.item(2);
        tri2.set('fill', colors[1]);

        let circle = group.item(4);
        circle.setGradient('fill',
            {
                x1: 0,
                y1: 0,
                x2: 0,
                y2: circle.height,
                colorStops: colors
            });
    }

    @HostListener('window:resize', ['$event'])
    private onResize(event) {
        this.canvas.setWidth(this.map.nativeElement.clientWidth);
        this.canvas.setHeight(this.map.nativeElement.clientHeight);
        this.scaleFactor = this.canvas.getWidth() / this.initialW;

        this.canvas.setZoom(this.scaleFactor);
        this.canvas.calcOffset();
        this.canvas.renderAll();
    }

    // Private methods
    private _highlightMap(mode: string) {
        if (mode) {
            this.highlightMap = true;
            this.mapMode = mode;
            return;
        }

        this.highlightMap = false;
        this.mapMode = null;
    }
}



// WEBPACK FOOTER //
// ./Angular/app/port/port.component.ts